declare global {
  interface Window {
    called: Record<string, boolean>
  }
}

const isCalled = (key: string) => {
  if (!window.called) {
    return false
  }

  return window.called[key]
}

const setCalled = (key: string) => {
  if (!window.called) {
    window.called = {
      [key]: true,
    }
  }

  window.called[key] = true
}

export const singleCall = (key: string, fn: () => Promise<void> | void) => {
  if (isCalled(key)) {
    return
  }

  setCalled(key)

  setTimeout(fn, 0)
}
